import createSagaMiddleware from '@redux-saga/core';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { AchievementsState } from './achievements/types';
import { AppOrganizationState } from './appOrganization/types';
import { AttachmentsState } from './attachments/types';
import { ChatState } from './bot/types';
import { CategoriesState } from './category/types';
import { CategoryManagementState } from './categoryManagement/types';
import { ClassificationsState } from './classification/types';
import { CommonState } from './common/types';
import { EvaluationQuestionState } from './evaluationQuestion/types';
import { FavoriteState } from './favorite/types';
import { FollowersState } from './followers/types';
import { HeaderState } from './header/types';
import { HighlightState } from './highlights/types';
import { IdentityState } from './identity/types';
import { ItensState } from './item/types';
import { LearningMapState } from './learningMap/types';
import { LessonsState } from './lesson/types';
import { ListsState } from './list/types';
import { ListItemsState } from './listItems/types';
import { LocaleState } from './locale/types';
import { OnboardState } from './onboard/types';
import { PeopleState } from './person/types';
import { ProgramState } from './program/types';
import { ProgramClassState } from './programClass/types';
import { PushNotificationState } from './pushNotification/types';
import { QuestionnaireState } from './questionnaire/types';
import { QuizState } from './quiz/types';
import { RatingState } from './rating/types';
import { ReportState } from './report/types';
import rootReducer from './rootReducer';
import rootSaga from './rootSagas';
import { SamlState } from './saml/types';
import { ScormState } from './scorm/types';
import { SearchState } from './search/types';
import { StudentState } from './student/types';
import { TagsState } from './tag/types';
import { UsersState } from './user/types';

export interface ApplicationState {
    identity: IdentityState;
    appOrganization: AppOrganizationState;
    locale: LocaleState;
    itens: ItensState;
    tags: TagsState;
    categories: CategoriesState;
    categoryManagement: CategoryManagementState;
    lists: ListsState;
    listItems: ListItemsState;
    users: UsersState;
    people: PeopleState;
    attachments: AttachmentsState;
    favorite: FavoriteState;
    rating: RatingState;
    classifications: ClassificationsState;
    highlights: HighlightState;
    search: SearchState;
    pushNotification: PushNotificationState;
    lessons: LessonsState;
    common: CommonState;
    programClass: ProgramClassState;
    header: HeaderState;
    questionnaire: QuestionnaireState;
    evaluationQuestion: EvaluationQuestionState;
    scorm: ScormState;
    program: ProgramState;
    onboard: OnboardState;
    quiz: QuizState;
    learningMap: LearningMapState;
    chat: ChatState;
    followers: FollowersState;
    report: ReportState;
    student: StudentState;
    achievements: AchievementsState;
    saml: SamlState;
}

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['identity', 'search', 'chat'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store: Store<ApplicationState> = createStore(persistedReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor };
